import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb"

import { get } from "helpers/api_helper"
import PackageCategoryForm from "components/PackageCategory/PackageCategoryForm"
import SpinnerLoader from "components/Loader/SpinnerLoader"
const EditPackageCategory = props => {
  const [package_category, setPackageCategory] = useState({})
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    setLoading(true)
    get(`package-categories/${props.match.params.id}`).then(res => {
      const { status, result } = res
      setPackageCategory(result)
      setLoading(false)
    })
  }, [])

  return (
    <div className="page-content">
      <MetaTags>
        <title>Package Category | GoFetchIt</title>
      </MetaTags>
      <div className="container-fluid">
        <Breadcrumb
          breadcrumb1={{
            title: "Package Categories",
            href: "/package-categories",
          }}
          breadcrumbItem="Edit Package Category"
        />
        {loading ? (
          <SpinnerLoader/>
        ) : (
          <PackageCategoryForm
            c_data={package_category}
            packageCategory_id={props.match.params.id}
          />
        )}
      </div>
    </div>
  )
}

export default EditPackageCategory
